var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.516 3C19.964 3 22 4.985 22 8.382h-4.231v.034c-1.964 0-3.556 1.552-3.556 3.467s1.592 3.467 3.556 3.467H22v.312C22 19.015 19.964 21 16.516 21H7.484C4.036 21 2 19.015 2 15.662V8.338C2 4.985 4.036 3 7.484 3h9.032Zm4.737 6.872c.413 0 .747.326.747.728v2.531a.746.746 0 0 1-.747.728H17.85c-.994.013-1.864-.65-2.089-1.595a1.982 1.982 0 0 1 .433-1.652 2.091 2.091 0 0 1 1.576-.74h3.484Zm-3.004 1.17h-.329a.766.766 0 0 0-.54.213.728.728 0 0 0-.224.524c0 .413.34.75.764.754h.329a.755.755 0 0 0 .764-.745.755.755 0 0 0-.764-.746Zm-5.867-4.15H6.738a.755.755 0 0 0-.765.736c0 .413.341.75.765.754h5.644a.755.755 0 0 0 .765-.745.755.755 0 0 0-.765-.746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.a982943f5b250a527ad6a76f3d20ecba.svg";
export { ForwardRef as ReactComponent };